import { IXepHangTotNghiepActionTypes } from "../../action-types/category/IXepHangTotNghiepActions";
import { IXepHangTotNghiepReducer } from "../../reducer-model/category/IXepHangTotNghiepReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";

const iniState = {
    status: eReducerStatusBase.is_not_initialization,
    xepHangTotNghieps: [],
}

export const xepHangTotNghiepReducer = (state = iniState, action: IXepHangTotNghiepActionTypes): IXepHangTotNghiepReducer => {
    switch (action.type) {
        case "XEP_HANG_TOT_NGHIEP_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "XEP_HANG_TOT_NGHIEP_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                xepHangTotNghieps: action.payload,
            };
        case "XEP_HANG_TOT_NGHIEP_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "XEP_HANG_TOT_NGHIEP_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                xepHangTotNghiepEditing: action.payload,
            };
        case "XEP_HANG_TOT_NGHIEP_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
            };
        case "XEP_HANG_TOT_NGHIEP_SAVE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving,
            };
        case "XEP_HANG_TOT_NGHIEP_SAVE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
                isShowEditModal: false,
            };
        case "XEP_HANG_TOT_NGHIEP_SAVE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "XEP_HANG_TOT_NGHIEP_DELETE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_deleting,
            };
        case "XEP_HANG_TOT_NGHIEP_DELETE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            };
        default:
            return state;
    }
}